var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-picker',{attrs:{"title":_vm.title,"accept":".xlsx, .xls, .csv"},on:{"input":_vm.change},model:{value:(_vm.files),callback:function ($$v) {_vm.files=$$v},expression:"files"}})}
var staticRenderFns = []

export { render, staticRenderFns }